import router from './router'
const whiteList = ['/login', '/login/manager']
router.beforeEach((to, from, next) => {
  if (whiteList.indexOf(to.path) !== -1) {
    next()
  } else {
    if (JSON.parse(sessionStorage.getItem('loginStatus'))) {
      next()
    } else {
      console.log(to)
      if (to.path.indexOf('/manager/') < 0) {
        next({
          path: '/login',
          query: { ...to.query },
        })
      } else {
        next({
          path: '/login/manager',
          query: { ...to.query },
        })
      }
    }
  }
  if (to.fullPath == '/login') {
    if (JSON.parse(localStorage.getItem('loginStatus'))) {
      next({
        path: from.fullPath,
      })
    } else {
      next()
    }
  }
})
